export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-zh-CN.ab0aff86.xlsx";